module.exports = __webpack_public_path__ + "img/status-3@3x.689f925c.png";